import React from 'react';

import {
  BackgroundStylingProps,
  DimensionStylingProps,
  MarginStylingProps,
  PaddingStylingProps,
  OverflowStylingProps,
} from '../../styling';

import { FlexContainer } from './FlexContainer';

interface FlexColumnProps {
  children: React.ReactNode;
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  alignContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'stretch'
    | 'space-between'
    | 'space-around'
    | 'normal';
  gap?: string;
  dimensions?: DimensionStylingProps;
  padding?: PaddingStylingProps;
  margin?: MarginStylingProps;
  overflow?: OverflowStylingProps;
  background?: BackgroundStylingProps;
}

export const FlexColumn = ({
  children,
  justifyContent,
  alignItems,
  alignContent,
  gap,
  dimensions,
  padding,
  margin,
  overflow,
  background,
}: FlexColumnProps) => (
  <FlexContainer
    flexDirection="column"
    justifyContent={justifyContent}
    alignItems={alignItems}
    alignContent={alignContent}
    gap={gap}
    dimensions={dimensions}
    padding={padding}
    margin={margin}
    overflow={overflow}
    background={background}
  >
    {children}
  </FlexContainer>
);
